import React from 'react'
import { cva, cx, type VariantProps } from 'class-variance-authority'

const inputVariants = cva(
  'text-slate-500 border-border relative block w-full rounded-md px-2 py-2.5 text-sm placeholder:text-sm focus:ring-offset-2 focus-visible:outline-none disabled:cursor-not-allowed disabled:bg-gray-100 disabled:text-gray-500',
  {
    variants: {
      variant: {
        default: 'focus:!border-border focus:ring-primary-500',
        error: 'border-red-500 placeholder:text-red-500',
        color: '!p-0',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
)

type InputProps = React.InputHTMLAttributes<HTMLInputElement> &
  VariantProps<typeof inputVariants> & {
    className?: string
    inputTextPosition?: 'left' | 'center' | 'right'
  }

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  (props, ref) => {
    const {
      inputTextPosition,
      className,
      variant,
      onFocus = (e) => e.target.select(),
      ...rest
    } = props
    return (
      <input
        ref={ref}
        onFocus={onFocus}
        style={{
          textAlign: inputTextPosition,
        }}
        className={cx(inputVariants({ variant }), className)}
        {...rest}
      />
    )
  },
)
Input.displayName = 'Input'
